import React, {useState, useEffect} from 'react'
import Preview from './CreateModalComponents/Preview'
import {convertStreamToURL} from '../../../../../utils/helper'
import AWS from 'aws-sdk'
import pause from '../../../../../_metronic/images/pause.png'
import {GLOBAL_CONSTANTS} from '../../../../../utils/GlobalConstants'
import clsx from 'clsx'

interface TabConfig {
  label: string
  value: string
}
export default function CreatePreview({
  payload,
  languagesSelected,
  speakingId,
  setSpeakingId,
  cancel,
  audio,
  audioRef,
  isplayingplayAll,
  setIsPlayingPlayAll,
  isSolarProduct,
}: any) {
  const [currentLanguageId, setCurrentLanguageId] = useState<any>()
  const [selectedLanguageId, setSelectedLanguageId] = useState()
  const [selectedLanguageName, setSelectedLanguageName] = useState('')
  const [dualQuestions, setDualQuestions] = useState([])
  const [electricQuestions, setElectricQuestions] = useState([])
  const [gasQuestions, setGasQuestions] = useState([])
  const [solarQuestions, setSolorQuestions] = useState<any>([])

  const [tab, setTab] = useState(
    isSolarProduct ? GLOBAL_CONSTANTS.scriptType.solar : GLOBAL_CONSTANTS.scriptType.dual
  )
  const [questions, setQuestions] = useState<any>([])
  useEffect(() => {
    setSelectedLanguageId(languagesSelected[0]?.value)

    setSelectedLanguageName(languagesSelected[0]?.label)
  }, [languagesSelected])
  useEffect(() => {
    cancel()
    setCurrentLanguageId(
      payload?.scriptQuestions?.find(({languageId}: any) => languageId === selectedLanguageId)
    )
  }, [selectedLanguageId])

  const languageConfig: any = {
    English: {
      languageCode: 'en-US',
      Male: 'Matthew',
      Female: 'Joanna',
    },
    Spanish: {
      languageCode: 'es-ES',
      Male: 'Miguel',
      Female: 'Lupe',
    },
  }

  useEffect(() => {
    setQuestions(
      payload?.scriptQuestions?.filter((item: any) => item?.languageId === selectedLanguageId)[0]
        ?.questions
    )
  }, [selectedLanguageId, payload])
  const handleSelectChange = (value: any) => {
    setSelectedLanguageId(value)
    setSelectedLanguageName(
      languagesSelected.filter((language: any) => language.value === value)[0]?.label
    )
  }
  useEffect(() => {
    const selectedLanguagequestions = payload?.scriptQuestions?.filter(
      (item: any) => item?.languageId === selectedLanguageId
    )[0]?.questions
    setDualQuestions(
      selectedLanguagequestions?.filter(
        (prompt: any) => prompt.scriptType === GLOBAL_CONSTANTS.scriptType.dual
      )
    )
    setElectricQuestions(
      selectedLanguagequestions?.filter(
        (prompt: any) => prompt.scriptType === GLOBAL_CONSTANTS.scriptType.electric
      )
    )
    setGasQuestions(
      selectedLanguagequestions?.filter(
        (prompt: any) => prompt.scriptType === GLOBAL_CONSTANTS.scriptType.gas
      )
    )
    setSolorQuestions(
      selectedLanguagequestions?.filter(
        (prompt: any) => prompt.scriptType === GLOBAL_CONSTANTS.scriptType.solar
      )
    )
  }, [selectedLanguageId])
  AWS.config.region = 'us-east-1'
  // Configure the credentials provider to use your identity pool
  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: process.env.REACT_APP_IDENDITY_POOL_ID as string,
  })
  let polly: any
  AWS.config.getCredentials((err, credentials) => {
    polly = new AWS.Polly({
      accessKeyId: credentials?.accessKeyId,
      secretAccessKey: credentials?.secretAccessKey,
      sessionToken: credentials?.sessionToken,
      region: 'us-east-1',
    })
  })

  const handleSpeech = (text: string, speakingQuestionId: any, isPlayAll: boolean) => {
    const params = {
      Text: text,
      OutputFormat: 'mp3',
      LanguageCode: languageConfig[selectedLanguageName].languageCode,
      VoiceId: languageConfig[selectedLanguageName][payload.voice],
    }
    polly.synthesizeSpeech(params, (err: any, data: any) => {
      if (err) {
        console.error(err)
      } else if (data) {
        audio.src = convertStreamToURL(data)
        audio.play()
        audio.addEventListener('ended', () => {
          setSpeakingId('')
        })
        setSpeakingId(speakingQuestionId)
      }
    })
  }

  const handlePlayAll = () => {
    let currentAudioIndex = 0
    if (!isplayingplayAll && !!selectedLanguageName) {
      Promise.all(
        questions
          ?.filter((question: any) => question.scriptType === tab)
          ?.map((question: any, index: any) => {
            const params = {
              Text: question?.description,
              OutputFormat: 'mp3',
              LanguageCode: languageConfig[selectedLanguageName]?.languageCode,
              VoiceId: languageConfig[selectedLanguageName]?.[payload.voice],
            }
            return polly
              .synthesizeSpeech(params)
              .promise()
              .then((data: any) => {
                return {
                  id: question?.id,
                  text: question?.description,
                  url: convertStreamToURL(data),
                }
              })
          })
      ).then((values) => {
        setIsPlayingPlayAll(true)
        audioRef?.current.addEventListener('ended', function () {
          setSpeakingId('')
          currentAudioIndex++
          if (
            currentAudioIndex <
            questions?.filter((question: any) => question.scriptType === tab).length
          ) {
            audioRef.current.src = values[currentAudioIndex]?.url
            audioRef.current.src && audioRef.current.play()
            setSpeakingId(values[currentAudioIndex]?.id)
            setIsPlayingPlayAll(true)
          } else {
            audioRef.current.pause()
            setIsPlayingPlayAll(false)
          }
        })
        audioRef.current.src = values[currentAudioIndex]?.url
        setSpeakingId(values[currentAudioIndex]?.id)
        audioRef.current.src && audioRef.current.play()
      })
    } else {
      cancel()
      setIsPlayingPlayAll(false)
    }
  }

  const tabsList = [
    {label: 'Both Electric and Gas', value: GLOBAL_CONSTANTS.scriptType.dual},
    {label: 'Electric', value: GLOBAL_CONSTANTS.scriptType.electric},
    {label: 'Gas', value: GLOBAL_CONSTANTS.scriptType.gas},
    {label: 'Solar', value: GLOBAL_CONSTANTS.scriptType.solar},
  ]

  const renderList = (tabConfig: TabConfig) => {
    return (
      <li className='nav-item' key={tabConfig.value}>
        <div
          className={clsx('tab-pane nav-link cursor-pointer text-gray-600 fs-4', {
            active: tab === tabConfig.value,
          })}
          role='tab'
          onClick={() => setTab(tabConfig.value)}
        >
          {tabConfig.label}
        </div>
      </li>
    )
  }

  return (
    <>
      <div className='container-xxl d-flex flex-stack  w-100 mb-4'>
        <h4 className='text-gray-800 fs-3 fw-bold'>Preview Prompts</h4>
        <div className='d-flex align-items-center gap-2 gap-lg-3'>
          <select
            className='form-select form-select-solid pe-17 bg-f4f4f4'
            value={selectedLanguageId}
            onChange={(e) => handleSelectChange(e.target.value)}
            aria-label='Select example'
          >
            {languagesSelected?.map((language: any) => {
              return (
                <option key={language.value} value={language.value}>
                  {language.label}
                </option>
              )
            })}
          </select>

          <button
            className='btn btn-active-light-primary btn-light-primary fs-6 px-5 py-3'
            onClick={() => handlePlayAll()}
            disabled={questions?.length === 0 || (!isplayingplayAll && speakingId)}
          >
            <div className='d-flex align-items-center'>
              {isplayingplayAll ? (
                <img src={pause} alt='pause-icon' />
              ) : (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  style={{fill: 'currentcolor'}}
                  height='16'
                  className='bi bi-play-fill'
                  viewBox='0 0 16 16'
                >
                  <path d='m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z' />
                </svg>
              )}
              <div className='fs-5 w-75px'>Play All</div>
            </div>
          </button>
        </div>
      </div>
      <div className='fixed-height-body'>
        <div className='tab d-flex flex-row justify-content-between mb-2'>
          <ul
            className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap'
            role='tablist'
          >
            {tabsList
              .filter((tabConfig) =>
                isSolarProduct ? tabConfig.label === 'Solar' : tabConfig.label !== 'Solar'
              )
              .map(renderList)}
          </ul>
        </div>
        <div className='tab-content pt-3'>
          <div className={clsx('tab-pane', {active: tab === GLOBAL_CONSTANTS.scriptType.dual})}>
            {questions
              ?.filter((question: any) => question.scriptType === GLOBAL_CONSTANTS.scriptType.dual)
              ?.map((question: any, index: any) => (
                <Preview
                  Key={question.id}
                  position={index + 1}
                  id={question.id}
                  languageName={selectedLanguageName}
                  question={question.description}
                  voice={payload.voice}
                  handleSpeech={handleSpeech}
                  speakingId={speakingId}
                  cancel={cancel}
                />
              ))}
          </div>
          <div className={clsx('tab-pane', {active: tab === GLOBAL_CONSTANTS.scriptType.electric})}>
            {questions
              ?.filter(
                (question: any) => question.scriptType === GLOBAL_CONSTANTS.scriptType.electric
              )
              ?.map((question: any, index: any) => (
                <Preview
                  Key={question.id}
                  position={index + 1}
                  id={question.id}
                  languageName={selectedLanguageName}
                  question={question.description}
                  voice={payload.voice}
                  handleSpeech={handleSpeech}
                  speakingId={speakingId}
                  cancel={cancel}
                />
              ))}
          </div>
          <div className={clsx('tab-pane', {active: tab === GLOBAL_CONSTANTS.scriptType.gas})}>
            {questions
              ?.filter((question: any) => question.scriptType === GLOBAL_CONSTANTS.scriptType.gas)
              ?.map((question: any, index: any) => (
                <Preview
                  Key={question.id}
                  position={index + 1}
                  id={question.id}
                  languageName={selectedLanguageName}
                  question={question.description}
                  voice={payload.voice}
                  handleSpeech={handleSpeech}
                  speakingId={speakingId}
                  cancel={cancel}
                />
              ))}
          </div>
          <div className={clsx('tab-pane', {active: tab === GLOBAL_CONSTANTS.scriptType.solar})}>
            {questions
              ?.filter((question: any) => question.scriptType === GLOBAL_CONSTANTS.scriptType.solar)
              ?.map((question: any, index: any) => (
                <Preview
                  Key={question.id}
                  position={index + 1}
                  id={question.id}
                  languageName={selectedLanguageName}
                  question={question.description}
                  voice={payload.voice}
                  handleSpeech={handleSpeech}
                  speakingId={speakingId}
                  cancel={cancel}
                />
              ))}
          </div>
        </div>
      </div>
    </>
  )
}
